import React from 'react';
import { Link } from 'react-router-dom';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Alert, Form, Button } from 'react-bootstrap';
import { Input, DateTimeInput, FormActions, Radio, Static } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import FontAwesome from 'react-fontawesome';
import { withTranslation } from 'react-i18next';

const SettingsForm = ({ error, handleSubmit, submitting, isReadonly, submitSucceeded, genderTypes, requireChildLastName, requireChildSchool,
	backPath, onCancel, initialValues, sameAsParent, sameAsParentChange, enableParentSelfBooking, hasSameAsParentChild, t }) => {
	const showGender = false;
	const sameAsParentEntries = [
		{
			label: t('Child_SameAsParent'),
			value: 'true'
		},
		{
			label: t('Child_NoSameAsParent'),
			value: 'false'
		}
	];

	const isNew = !initialValues || !initialValues.id || initialValues.id == 0;
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			{enableParentSelfBooking && isNew && !hasSameAsParentChild && <Field name='sameAsParent' horizontal inline
				component={Radio}
				entries={sameAsParentEntries}
				onChange={sameAsParentChange}
				parse={value => value === 'true'}
			/>}
			{sameAsParent && !isNew && <Field name='fullName' component={Static} horizontal label={t('FO_Child_ChildName')} />}
			{!sameAsParent && <Field name='firstName' component={Input} horizontal required={!sameAsParent} type='text' label={t('FO_Child_ChildName')} validate={validators.required} />}
			{!sameAsParent && <Field name='lastName' component={Input} horizontal required={requireChildLastName && !sameAsParent} type='text' label={t('FO_Child_LastName')} validate={requireChildLastName && validators.required} />}
			{!sameAsParent && requireChildSchool && <Field name='schoolName' component={Input} horizontal required={requireChildSchool && !sameAsParent} type='text' label={t('FO_Child_SchoolName')} validate={requireChildSchool && validators.required} />}
			{showGender && initialValues && <Field name='genderId' component={Input} componentClass='select' horizontal label={t('FO_Child_Gender')}>
				<option />
				{genderTypes && genderTypes.map(item => <option key={item.id} value={item.id}>{item.displayName ? item.displayName : item.name}</option>)}
			</Field>}
			<Field name='dateOfBirth' component={DateTimeInput} horizontal required showTime={false} label={t('FO_Child_DateOfBirth')} validate={[validators.requiredDate, validators.dateInThePast]} />
			<FormActions horizontal>
				<Button type='submit' disabled={isReadonly || submitting} bsStyle='primary' className='pull-right btn-block-xxs'>{t('Common_Save')} <FontAwesome name='arrow-circle-right' /></Button>
				{backPath && <Link to={backPath} className='btn btn-back btn-block-xxs'><FontAwesome name='arrow-circle-left' /> {t('Common_BackToList')}</Link>}
				{onCancel && <Button onClick={onCancel} className='btn btn-back btn-block-xxs'><FontAwesome name='arrow-circle-left' /> {t('Common_Cancel')}</Button>}
			</FormActions>
		</Form>
	);
};

export default reduxForm({ form: 'child', enableReinitialize: true })(withTranslation()(SettingsForm));
export const selector = formValueSelector('childSettingsForm');

